import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import OfferAuthorizedSignatoryStaffPanel from '../../../widgets/offerAuthorizedSignatoryStaff/OfferAuthorizedSignatoryStaffPanel'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getNotMakeContract } from '../../../redux/actions/contract'
import NotMakeContractPanel from '../../../widgets/makeContract/NotMakeContractPanel'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'

export default function CenterRequestNotMakeContract() {
  //มีคำร้องขอไม่ทำสัญญา/ข้อตกลง
  const [isEditAll, setIsEditAll] = useState(false)
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getNotMakeContract(projectVersionId)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={6}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema?.forms && (
          <>
            {/* <AgreementAdditionalWidgets
              showCommandButton={true}
              formSchema={schema.forms.requestDetails}
            /> */}

            <NotMakeContractPanel
              showCommandButton={true}
              isEditAll={isEditAll}
              schema={schema.forms}
              isContractCenter={true}
            />
          </>
        )}
      </SidebarProposal>
    </>
  )
}

const mockSchema = {
  header: 'มีคำร้องขอไม่ทำสัญญา/ข้อตกลง (mockup)',
  subHeader: 'ข้อเสนอโครงการ เด็กฉลาด ชาติเจริญ',
  forms: {
    id: null,
    header: 'คำร้องขอไม่ทำสัญญา/ข้อตกลง',
    buttonText: 'อนุมัติไม่ทำสัญญา/ข้อตกลง',
    file: {
      fileName: null,
    },
    note: {
      name: 'note',
      label: 'แสดงความคิดเห็น',
      value: '',
      hint: 'ระบุความคิดเห็น',
      validators: [
        {
          type: 'REQUIRED',
          value: null,
          errorMessage: 'กรุณากรอก ความคิดเห็น',
        },
      ],
    },
    requestDetails: {
      title: 'รายละเอียดคำร้องขอไม่ทำสัญญา/ข้อตกลง (ภาคี)',
      content:
        'ขอไม่ทำสัญญา เนื่องจาก ข้าพเจ้าไม่สามารถยอมรับสัญญา/ข้อตกลงนี้ได้ จึงขอไม่ทำสัญญา/ขอตกลง',
      datetime: {
        dateLabel: 'วันที่ : ',
        dateValue: '24 พฤษภาคม 2564',
        timeLabel: 'เวลา : ',
        timeValue: '08:23',
      },
      status: {
        statusLabel: 'สถานะ : ',
        statusValue: 'รอพิจารณาอนุมัติไม่ทำสัญญา/ข้อตกลง',
      },
    },
  },
}
